var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"content"},[_c('ListCart',{attrs:{"tableData":[..._vm.tableData, ..._vm.invalidList],"dataListLoading":_vm.loading},on:{"refresh":_vm.doSearch}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }